export const journalTemplate = 'Week 1:\nWeek 2:\nWeek 3:\nWeek 4:\nWeek 5:'
export const minCharacters = 20
